import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Loading from './components/common/Loading';
import Login from './pages/Login';
import PublicQuotation from './pages/PublicQuotation';
import AdminLayout from "./pages/AdminLayout";
import Dashboard from './pages/Dashboard';
import Quotations from './pages/Quotations';
import QuotationDetail from './pages/QuotationDetail';
import Invoices from './pages/Invoices';
import InvoiceDetail from './pages/InvoiceDetail';
import Employees from './pages/Employees';
import EmployeeDetail from './pages/EmployeeDetail';
import PaymentAccounts from './pages/PaymentAccounts';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Inventory from './pages/Inventory';
import InventoryDetail from './pages/InventoryDetail';
import ProjectCostSheets from './pages/ProjectCostSheets';
import ProjectCostSheetDetail from './pages/ProjectCostSheetDetail';
import Dalale from './pages/Dalale';
import DalaleDetail from './pages/DalaleDetail';
import ApartmentRegistry from './pages/ApartmentRegistry';
import UserManagement from './pages/UserManagement';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, userData } = useAuth();
  if (loading) return <Loading fullScreen />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (userData?.isActive === false) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicQuotation />} />
        <Route path="/quote" element={<PublicQuotation />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="quotations" element={<Quotations />} />
          <Route path="quotations/:id" element={<QuotationDetail />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="invoices/:id" element={<InvoiceDetail />} />
          <Route path="employees" element={<Employees />} />
          <Route path="employees/:id" element={<EmployeeDetail />} />
          <Route path="payments" element={<PaymentAccounts />} />
          <Route path="reports" element={<Reports />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="inventory/:id" element={<InventoryDetail />} />
          <Route path="settings" element={<Settings />} />
          <Route path="project-costs" element={<ProjectCostSheets />} />
          <Route path="project-costs/:id" element={<ProjectCostSheetDetail />} />
          <Route path="dalale" element={<Dalale />} />
          <Route path="dalale/:id" element={<DalaleDetail />} />
          <Route path="apartment-registry" element={<ApartmentRegistry />} />
          <Route path="users" element={<UserManagement />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;